import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

export interface UIConfig {
  client: Client
  assets: Assets
  colors: Colors
}
export interface Assets {
  logo: string
  background: string
}
export interface Colors {
  primary: string
  secondary: string
}
export interface Client {
  name: string;
}


@Injectable({
  providedIn: 'root'
})
export class BrandingService {

  constructor() { }

  getUiConfig(clientId: string):Observable<UIConfig> {
    if(clientId === 'MyProfile') {
      const uiConfig = {
        client: {
          name: 'My Profile'
        },
        assets: {
          logo: '../../../../assets/images/image1.png',
          background: '../../../../assets/images/background.png'
        },
        colors: {
          primary: 'black',
          secondary: 'white'
        }
      };
      return of(uiConfig);
    }else if(clientId === 'demo_app') {
      const uiConfig = {
        client: {
          name: 'Demo App'
        },
        assets: {
          logo: '../../../../assets/images/b_logo.png',
          background: '../../../../assets/images/bg2.png'
        },
        colors: {
          primary: '#fff',
          secondary: '#000'
        }
      };
      return of(uiConfig);
    } else {      
      const uiConfig = {
        client: {
          name: 'Spark'
        },
        assets: {
          logo: '../../../../assets/images/image1.png',
          background: 'https://img.freepik.com/free-photo/creative-scene-composition-product-presentation_23-2148992091.jpg'
        },
        colors: {
          primary: 'black',
          secondary: 'white'
        }
      };
      return of(uiConfig);      
    }
  }

  setUiConfig(config: any) {
    localStorage.setItem('ui-config', config);
  }

  getUiConfigFromLocal() {
    return localStorage.getItem('ui-config');
  }

}
